import React from 'react';
import I18n from 'i18n-js';

import SiteModule from '@reverbdotcom/commons/src/components/site_module';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import OverflowingRow from '@reverbdotcom/commons/src/components/overflowing_row';
import Tiles from '@reverbdotcom/commons/src/components/tiles';


import brandedImage from '../../../images/price-guide-tool/branded-image.png';
import mobileHeader from '../../../images/price-guide-tool/mobile-header-background.png';
import URLHelpers from '../shared/url_helpers';
import PriceGuideToolUsage from './price_guide_tool_usage';

const COMPONENT_NAME = 'PriceGuideToolPageWrapper';

interface IProps {
  children?: React.ReactNode;
  parentComponentName?: string;
}

export function PriceGuideToolPageWrapper({ children, parentComponentName }: IProps) {
  return (
    <div className="price-guide-tool-page-wrapper">
      <div className="price-guide-tool-page-wrapper__img-header"></div>
      <div className="price-guide-tool-page-wrapper__content">
        <div className="price-guide-tool-page-wrapper__content__overview">
          <h1>
            {I18n.t('discovery.priceGuideTool.wrapper.title')}
          </h1>
          <p>
            {I18n.t('discovery.priceGuideTool.wrapper.overview')}
          </p>
          <div className="price-guide-tool-page-wrapper__mobile-header-image-container">
            <img
              src={mobileHeader}
              alt={I18n.t('discovery.priceGuideTool.wrapper.mobileHeaderAltText')}
            />
          </div>
        </div>
        <SiteModule>
          <h2 className="price-guide-tool-page-wrapper__content__module-title">
            {I18n.t('discovery.priceGuideTool.index.search.title')}
          </h2>
          {children}
        </SiteModule>
        <PriceGuideToolUsage />
      </div>

      <div className="price-guide-tool-page-wrapper__estimated-value-info">
        <div className="price-guide-tool-page-wrapper__estimated-value-info__content">
          <div className="price-guide-tool-page-wrapper__estimated-value-info__content__image-container">
            <img
              src={brandedImage}
              alt={I18n.t('discovery.priceGuideTool.wrapper.estimatedValueInfo.brandedIcon')}
            />
          </div>
          <div className="price-guide-tool-page-wrapper__estimated-value-info__content__text-container">
            <h3 className="price-guide-tool-page-wrapper__estimated-value-info__title">
              {I18n.t('discovery.priceGuideTool.wrapper.estimatedValueInfo.title')}
            </h3>
            <p>
              {I18n.t('discovery.priceGuideTool.wrapper.estimatedValueInfo.paragraphOne')}
            </p>
            <p>
              {I18n.t('discovery.priceGuideTool.wrapper.estimatedValueInfo.paragraphTwo')}
            </p>
          </div>
        </div>
      </div>

      <div className="price-guide-tool-page-wrapper__articles">
        <h3 className="price-guide-tool-page-wrapper__articles__learn-more">
          {I18n.t('discovery.priceGuideTool.wrapper.articles.learnMore')}
        </h3>
        <OverflowingRow>
          <Tiles
            grow
            singleRow
            threeWide
          >
            <CoreLink className="price-guide-tool-page-wrapper__articles__article"
              to={URLHelpers.datingGearGuidePath()}
              target="_blank"
              clickEvent={{
                componentName: parentComponentName || COMPONENT_NAME,
                eventName: MParticleEventName.ClickedHowToDateYourGearFromPriceGuideTool,
              }}
            >
              <div className="price-guide-tool-page-wrapper__articles__article__image-container price-guide-tool-page-wrapper__articles__article__image-container--date-gear">
              </div>
              <div className="price-guide-tool-page-wrapper__articles__article__text-container">
                <h3>
                  {I18n.t('discovery.priceGuideTool.wrapper.articles.dateGear.title')}
                </h3>
                <p>
                  {I18n.t('discovery.priceGuideTool.wrapper.articles.dateGear.description')}
                </p>
              </div>
            </CoreLink>
            <CoreLink className="price-guide-tool-page-wrapper__articles__article"
              to={URLHelpers.gearChangeGuidePath()}
              target="_blank"
              clickEvent={{
                componentName: parentComponentName || COMPONENT_NAME,
                eventName: MParticleEventName.ClickedHowGearChangesOverTimeFromPriceGuideTool,
              }}
            >
              <div className="price-guide-tool-page-wrapper__articles__article__image-container price-guide-tool-page-wrapper__articles__article__image-container--gear-change">
              </div>
              <div className="price-guide-tool-page-wrapper__articles__article__text-container">
                <h3>
                  {I18n.t('discovery.priceGuideTool.wrapper.articles.gearChanges.title')}
                </h3>
                <p>
                  {I18n.t('discovery.priceGuideTool.wrapper.articles.gearChanges.description')}
                </p>
              </div>
            </CoreLink>
            <CoreLink className="price-guide-tool-page-wrapper__articles__article"
              to={URLHelpers.vintageFAQGuidePath()}
              target="_blank"
              clickEvent={{
                componentName: parentComponentName || COMPONENT_NAME,
                eventName: MParticleEventName.ClickedVintageGuitarFAQFromPriceGuideTool,
              }}
            >
              <div className="price-guide-tool-page-wrapper__articles__article__image-container price-guide-tool-page-wrapper__articles__article__image-container--vintage-faq">
              </div>
              <div className="price-guide-tool-page-wrapper__articles__article__text-container">
                <h3>
                  {I18n.t('discovery.priceGuideTool.wrapper.articles.faq.title')}
                </h3>
                <p>
                  {I18n.t('discovery.priceGuideTool.wrapper.articles.faq.description')}
                </p>
              </div>
            </CoreLink>
          </Tiles>
        </OverflowingRow>
      </div>
    </div>
  );
}

export default PriceGuideToolPageWrapper;
